import * as Actions from './Actions';
import { Modal, Button } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import { assign } from '../../shared/Assign';
import * as React from 'react';
import { connect } from 'react-redux';
import IPlanEditorInput from './IPlanEditorInput';
import { handleError } from '../../shared/ErrorCatching';
import PlanEditorForm from './PlanEditorForm';
import notify from '../../shared/feedback/notifications';

export class PlanEditorModal extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            input: {
                planFirmId: '',
                role: '',
                name: '',
                username: '',
                email: '',
                phoneNumber: ''
            },
            availableRoles: [],
            planFirms: [],
            errors: {},
            creating: false,
            availableLanguages: []
        };

        this.save = this.save.bind(this);
        this.create = this.create.bind(this);
        this.onFormInputChange = this.onFormInputChange.bind(this);
    }

    componentDidMount() {
        if (this.props.editId > 0) {
            this.props.actions
                .edit(this.props.editId)
                .then(() => {
                    this.setState({
                        input: assign({}, this.props.edit.planEditor),
                        planFirms: this.props.edit.planFirms,
                        availableRoles: this.props.edit.availableRoles,
                        availableLanguages: this.props.edit.availableLanguages
                    });
                })
                .catch((error: any) => handleError(error));
        } else {
            this.props.actions
                .new()
                .then(() => {
                    this.setState({
                        input: {},
                        planFirms: this.props.new.planFirms,
                        availableRoles: this.props.new.availableRoles,
                        availableLanguages: this.props.new.availableLanguages
                    });
                })
                .catch((error: any) => handleError(error));
        }
    }

    onFormInputChange(e: any): void {
        let input = this.state.input;
        const value = e.target.value;

        input[e.target.name] = value;

        this.setState({ input: assign({}, input) });
    }

    save(): void {
        this.setState({ creating: true });
        if (this.props.editId > 0) {
            this.update();
        } else {
            this.checkForEmail();
            this.create();
        }
    }

    checkForEmail() {
        let input = this.state.input;

        if (!input.email && input.username) {
            input.email = input.username;

            this.setState({ input: assign({}, input) });
        }
    }

    create() {
        this.props.actions
            .create(this.state.input)
            .then(() => {
                this.setState({ creating: false });
                this.props.closeModal();
                notify.success(Translate('plan-editors/notification/added'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, creating: false });
                })
            );
    }

    update(): void {
        this.props.actions
            .update(this.state.input)
            .then(() => {
                this.setState({ creating: false });
                this.props.closeModal();
                notify.success(Translate('plan-editors/notification/updated'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, creating: false });
                })
            );
    }

    render() {
        return (
            <div>
                <Modal show={this.props.shouldShowModal} onHide={this.props.closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.props.editId > 0
                                ? Translate('plan-editors/modal/titles/edit')
                                : Translate('plan-editors/modal/titles/add')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <PlanEditorForm
                            input={this.state.input}
                            planFirms={this.state.planFirms}
                            availableRoles={this.state.availableRoles}
                            onChange={this.onFormInputChange}
                            errors={this.state.errors}
                            isEditMode={this.props.editId > 0}
                            availableLanguages={this.state.availableLanguages}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.props.closeModal}>
                            {Translate('plan-editors/modal/button-labels/close')}
                        </Button>
                        <Button
                            disabled={this.state.creating}
                            bsStyle="primary"
                            onClick={this.save}
                        >
                            {Translate('plan-editors/modal/button-labels/save')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        new: state.planEditors.new,
        edit: state.planEditors.edit
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            new: () => dispatch(Actions.getNew()),
            create: (input: IPlanEditorInput) => dispatch(Actions.create(input)),
            edit: (id: number) => dispatch(Actions.edit(id)),
            update: (input: IPlanEditorInput) => dispatch(Actions.update(input))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanEditorModal);
